<button matIconButton matTooltip="{{ 'menu.help' | translate }}">
    <mat-icon aria-hidden="false">help_outline</mat-icon>
</button>